import cookie from "../_cookie";

const localizationForms = [...document.querySelectorAll('.shopify-localization-form')];
const languageSelectors = [...document.querySelectorAll('.js-language-switch')];
const formsAndSelectors = [...localizationForms, ...languageSelectors];

formsAndSelectors.map(form => {
    const inputs = form.querySelectorAll('input[name="language_code"], input[name="country_code"]');

    [...form.querySelectorAll('.js-locale-link')].map(link => {
        link.addEventListener('click', e => {

            e.preventDefault();

            cookie.set('selectedLanguage', e.currentTarget.getAttribute('data-value'), 30)

            inputs.forEach(input => {
                input.value = e.currentTarget.getAttribute('data-value');
            });

            if (form) form.submit();
        })
        form.addEventListener('change', e => {

            e.preventDefault();

            cookie.set('selectedLanguage', e.currentTarget.getAttribute('data-value'), 30)

            inputs.forEach(input => {
                input.value = e.currentTarget.querySelector('.language-switch__select').value;
            });

            if (form) form.submit();
        })
    });
})
